// extracted by mini-css-extract-plugin
export default {"features":"LandingFeatures_features__st6zS","features-image-container":"LandingFeatures_features-image-container__wuAP9","features-image":"LandingFeatures_features-image__-i06+"};